export default "__VITE_ASSET__C4zna6yF__"